// extracted by mini-css-extract-plugin
export default {"containerDots":"dots_containerDots__+CCIh","dot":"dots_dot__j6RC6","dotActive":"dots_dotActive__tWu6V"};